import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    primary: {},
    disabled: {},
    secondary: {},

    btn: {
        border: 0,
        fontSize: 12,
        padding: 10,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        letterSpacing: 0.48,
        borderRadius: 2,
        textTransform: 'uppercase',

        '&$primary': {
            backgroundColor: theme.colors.brand.pink,
            color: theme.colors.text.light,

            '&:hover': {
                backgroundColor: '#c62742',
            },
        },

        '&$secondary': {
            backgroundColor: theme.colors.brand.blue,
            color: theme.colors.text.light,

            '&:hover': {
                backgroundColor: '#2c53df',
            },
        },

        '&$disabled': {
            backgroundColor: theme.colors.light.grey,
            color: theme.colors.light.darkgrey,
        },
    },

    fullWidth: {
        width: '100%',
    },
}))
